import PositionDto from '@/models/Positions/PositionDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import WorkerDto from '@/models/Workers/WorkerDto';
import WorkerPositionStatus from '@/models/WorkerPositions/WorkerPositionStatus';
import WorkType from '@/models/Shared/WorkType';

export default class WorkerPositionDto extends BaseAgencyScopeEntityDto {
    workerId: string;
    worker: WorkerDto = new WorkerDto();
    positionId: string;
    position: PositionDto = new PositionDto();
    payRate: number;
    status: WorkerPositionStatus;
    workTypes: WorkType[];
    isVerified = false;
}